var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_vm._m(0),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.msg||"暂无数据"))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"el-icon-warning-outline"})])
}]

export { render, staticRenderFns }